import { formatProcedures } from 'lib/helpers/formatProcedures';

import OverflowChipList from '../OverflowChipList';

import { CODE_CHIP_PARAMS } from './constants';

/**
 * AG Grid column pieces for procedure chips. `getProcedures(data)` returns the row's procedures
 * ({ procedure_code, name }) or ready-made labels; spread the result into a column def and add or
 * override anything else (field, width, cellClass, an export valueFormatter) after it.
 */
const chipColumn = ({ headerName, getProcedures, isCodesOnly }) => ({
  headerName,
  cellRenderer: OverflowChipList,
  ...(isCodesOnly && { cellRendererParams: CODE_CHIP_PARAMS }),
  valueGetter: ({ data }) => formatProcedures(getProcedures(data), isCodesOnly),
  cellClass: 'overflow-hidden'
});

// "Code - name" chips, or the name when a service has no code.
export const servicesColumn = (getProcedures) =>
  chipColumn({ headerName: 'Services', getProcedures, isCodesOnly: false });

// Code-only chips: exactly two show side by side, more collapse to one code and "+N".
export const procedureCodesColumn = (getProcedures) =>
  chipColumn({ headerName: 'Procedure codes', getProcedures, isCodesOnly: true });
